import { useLiveClassState } from '../../../hooks/liveClassStore';
import { VideoParticipantTile } from './VideoParticipantTile';

/**
 * Área principal de la clase: solo el video del profesor en grande.
 *
 * Los alumnos conectados se administran desde el tab «En vivo»; así el video y
 * la pantalla compartida se quedan con todo el espacio disponible.
 */
export const VideoMainStage = ({ hidden = false }) => {
    const participants = useLiveClassState((s) => s.participants);
    const speakingUserIds = useLiveClassState((s) => s.speakingUserIds);
    const connection = useLiveClassState((s) => s.connection);

    const host = participants.find((p) => p.isHost)
        || participants.find((p) => p.isManager)
        || null;

    // Con pantalla compartida o pizarra se desmonta: el contenido manda y el
    // SDK deja de decodificar un video que nadie ve.
    if (hidden) return null;

    if (!host) {
        return (
            <div className="vc-stage__main is-empty">
                <p className="vc-stage__placeholder">
                    {connection === 'reconnecting'
                        ? 'Reconectando con la clase…'
                        : 'Esperando a que el profesor se conecte…'}
                </p>
            </div>
        );
    }

    return (
        <div className="vc-stage__main">
            <VideoParticipantTile
                participant={host}
                variant="stage"
                isActiveSpeaker={speakingUserIds.includes(host.userId)}
            />
            {!host.bVideoOn ? (
                <p className="vc-stage__hint">
                    {host.isSelf
                        ? 'Tu cámara está apagada'
                        : 'El profesor aún no enciende su cámara'}
                </p>
            ) : null}
        </div>
    );
};
